// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer_container__181hO","cp":"Footer_cp__1hBUX"};